import { createReference, isResource } from "@medplum/core";
import type { Reference, Resource } from "@medplum/fhirtypes";

/**
 * Merges amend-session Provenance targets with base targets, deduped by reference string.
 */
export function mergeLaborAmendProvenanceTargets(
  baseTargets: Reference<Resource>[],
  amendSessionTargets: Reference<Resource>[],
): Reference<Resource>[] {
  const merged = [...baseTargets];
  const seenReferences = new Set(
    merged.map((target) => target.reference).filter(Boolean) as string[],
  );

  for (const target of amendSessionTargets) {
    const reference = target.reference;
    if (!reference || seenReferences.has(reference)) {
      continue;
    }
    seenReferences.add(reference);
    merged.push(target);
  }

  return merged;
}

/**
 * Converts a resource or reference into a deduped Provenance target reference.
 */
export function toLaborAmendProvenanceTargetReference(
  resourceOrReference: Resource | Reference<Resource>,
): Reference<Resource> | undefined {
  if (isResource(resourceOrReference)) {
    return createReference(resourceOrReference);
  }
  if (resourceOrReference.reference) {
    return { reference: resourceOrReference.reference };
  }
  return undefined;
}
